var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHostIconBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "@0.5xicon/person/black copy 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scheduler-+-Profile-Association",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Person-Scheduler---Daily-view",
    transform: "translate(-157.000000, -216.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(89.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "host",
    transform: "translate(60.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,21.760479 C15.8662718,21.760479 16.8163621,21.8862263 17.8502994,22.1377246 C19.023958,22.4311392 19.9740483,22.8223528 20.7005988,23.3113772 C21.5668706,23.8842344 22,24.5269425 22,25.239521 L22,27 L8,27 L8,25.239521 C8,24.5269425 8.4331294,23.8842344 9.2994012,23.3113772 C10.0259517,22.8223528 10.976042,22.4311392 12.1497006,22.1377246 C13.1836379,21.8862263 14.1337282,21.760479 15,21.760479 Z M15,20 C14.3712543,20 13.7914198,19.8428159 13.260479,19.5284431 C12.7295383,19.2140703 12.3068878,18.7914198 11.992515,18.260479 C11.6781421,17.7295383 11.5209581,17.1497037 11.5209581,16.5209581 C11.5209581,15.8922124 11.6781421,15.3053919 11.992515,14.760479 C12.3068878,14.2155661 12.7295383,13.7859297 13.260479,13.4715569 C13.7914198,13.1571841 14.3712543,13 15,13 C15.6287457,13 16.2085802,13.1571841 16.739521,13.4715569 C17.2704617,13.7859297 17.6931122,14.2155661 18.007485,14.760479 C18.3218579,15.3053919 18.4790419,15.8922124 18.4790419,16.5209581 C18.4790419,17.1497037 18.3218579,17.7295383 18.007485,18.260479 C17.6931122,18.7914198 17.2704617,19.2140703 16.739521,19.5284431 C16.2085802,19.8428159 15.6287457,20 15,20 Z",
    id: "icon/person/black-copy-24"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostIconBlack);
export default __webpack_public_path__ + "static/media/host_icon_black.484357261ceb2ed309a882eccbb951ee.svg";
export { ForwardRef as ReactComponent };